module.exports = __webpack_public_path__ + "static/media/IMG_4421.3519eb0f.jpg";